import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Api } from '@.api';
import { UserResource } from '@.api/methods';
import { Layout } from '@.layout';
import { UserForm } from '@/Components/Partials/User';
import { LinkHelper } from '@/Services';

import S from './UserEditPage.module.scss';

export const UserEditPage = () => {
    const params = useParams();

    const [userData, setUserData] = useState<UserResource | undefined>();

    const id = params.id ? Number(params.id) : undefined;

    const breadcrumbs = [
        { name: 'Users', link: LinkHelper.settingsUsers },
        { name: userData?.name || '', link: LinkHelper.settingsUserId(Number(id)) },
        { name: 'Edit', current: true },
    ];

    useEffect(() => {
        if (id) {
            Api.users()
                .getById(id)
                .onSuccess((res) => {
                    setUserData(res.data);
                });
        }
    }, [id]);

    return (
        <Layout contentClassName={S.root} name="settings" breadcrumbs={breadcrumbs} small>
            <UserForm title="Editing user" isEdit userId={id} initialResponseUserData={userData} />
        </Layout>
    );
};
